import { RESPONSIVE_GRID_TWO_TO_ONE_COLUMN_CLASS_NAME } from '../constants/responsive-grid-layout';

export const STATISTICS_PAGE_CONTENT_CLASS_NAME =
  'flex w-full flex-col gap-6 max-[1024px]:gap-[16px]';

export const STATISTICS_DAILY_OVERVIEW_GRID_CLASS_NAME = `${RESPONSIVE_GRID_TWO_TO_ONE_COLUMN_CLASS_NAME} items-stretch gap-[16px]`;

export const STATISTICS_PERIOD_CHART_GRID_CLASS_NAME =
  'grid grid-cols-3 gap-5 max-[1024px]:grid-cols-1';

export const STATISTICS_DAILY_ROOT_CLASS_NAME = 'flex h-full min-h-0 flex-col';

export const STATISTICS_DAILY_SALES_SECTION_CLASS_NAME =
  'relative mt-[34px] flex h-[var(--statistics-calendar-height)] max-h-[var(--statistics-calendar-height)] min-h-0 flex-none flex-col overflow-hidden rounded-[16px] bg-white p-5 max-[1024px]:mt-0 max-[1024px]:h-auto max-[1024px]:max-h-[480px]';
